"use client"
import {Link} from "@heroui/link";
import {useMonitoring} from "@/components/monitoring";

function onFeedbackClicked() {
    window.open('https://tally.so/r/w42pbr', '_blank')
}

export default function Footer() {
    const {onClickTrack} = useMonitoring()
    return (
        <footer className="w-full flex items-center justify-center py-3 gap-4 flex-col md:flex-row">
            {/*<span>{new Date().getFullYear()} © All rights reserved</span>*/}
            {/*<div>{"⸱"}</div>*/}
            <Link
                onClick={onClickTrack('Footer Item', {item: 'chrome-extension'})}
                isExternal
                className="flex items-center text-current"
                href="/chrome-extension"
                title="Chrome Extension installation page"
            >
                Chrome Extension
            </Link>
            <div>{"⸱"}</div>
            <Link
                onClick={onClickTrack('Footer Item', {item: 'contact-us'})}
                isExternal
                className="flex items-center text-current"
                href="/contact"
                title="Contact us"
            >
                Contact Us
            </Link>
            <div>{"⸱"}</div>
            <Link
                onClick={onClickTrack('Footer Item', {item: 'privacy-policy'})}
                isExternal
                className="flex items-center text-current"
                href="/privacy-policy"
                title="Privacy Policy"
            >
                Privacy Policy
            </Link>
            {/*<div>{"⸱"}</div>*/}
            {/*<Link*/}
            {/*    onClick={onClickTrack('Footer Item', {item: 'notionful'})}*/}
            {/*    isExternal*/}
            {/*    className="flex items-center text-current"*/}
            {/*    href="https://notionful.website"*/}
            {/*    title="Built with Notionful"*/}
            {/*>*/}
            {/*    <div className={"flex gap-1 items-center"}>*/}
            {/*        /!*<Image width={30} height={30} src="/notionful-logo.jpg"/>*!/*/}
            {/*        Built with <b>Notionful</b>*/}
            {/*    </div>*/}
            {/*</Link>*/}
        </footer>
    )
}
